import React, { Component } from 'react';
import { connect } from 'react-redux';

import ClientHeader from '../Header/ClientHeader';


import styles from './ClientMap.scss';
import withValidTrafic from 'decorators/withValidTrafic';
import YMap from '../Buildings/YMap';
import { loadData } from '../../actions/objects';

@withValidTrafic()
class Collection extends Component {

  componentDidMount() {
    const { loadData } = this.props;

    loadData(false, {
      limit: 10,
      orderField: 'date_update',
      orderDirection: 'DESC',
      region: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6'
      ],
      deadlineEnd: false,
      typeId: 1
    }, true);
  }

  render() {
    const {
      dispatch,
      buildings,
      match: { params }
    } = this.props;

    return (
      <ClientHeader params={params}>
        <div className={styles.ClientMap}>
          { buildings &&
            <YMap
              dispatch={dispatch}
              data={buildings}
              infoType="medium"
            />
          }
        </div>
      </ClientHeader>
    );
  }
}

export default connect(
  ({ collection, objects }) => ({
    collection,
    objects
  }), {
    loadData
  }
)(Collection);



// WEBPACK FOOTER //
// ./src/components/ClientMap/ClientMap.js